import { FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query"
import { AuthActionPayload } from "../../auth-slice/types"
import { FavoriteActionPayload } from "../../favorites-slice/types"
import { AuthenticatedResponse, CheckFavoriteRequest, FavoriteResponse, SpecificNotificationRequest } from "./types"
import { AddNotificationActionPayload, AddNotificationsActionPayload, GetPendingNotificationsResponse, SpecificNotificationActionPayload } from "../../notifications-slice/types"
import { TMNotificationPriority, TMNotificationType } from "../../../../notification-system"
import { toSubscriptionState } from "../../../types"

export const transformAuthenticatedResponse = (response: AuthenticatedResponse,): AuthActionPayload => {
  response.data.user.uuid = response.data.uuid
  return {
    user: response.data.user,
    token: response.data.token,
    showRegisterModal: response.data.showRegisterModal ?? false,
    subscription: response.data.subscription ? {
      ...response.data.subscription,
      state: toSubscriptionState(response.data.subscription.state),
    } : undefined,
  }
}

export const transformFavoriteResponse = (
  response: FavoriteResponse, 
  meta: FetchBaseQueryMeta | undefined, 
  arg: CheckFavoriteRequest
): FavoriteActionPayload => {
  return {
    contentId: arg.content_id,
    contentType: 'article',
    isFavorite: true,
  }
}

export const transformFavoriteErrorResponse = (
  error: FetchBaseQueryError, 
  meta: FetchBaseQueryMeta | undefined, 
  arg: CheckFavoriteRequest
): FavoriteActionPayload => {
  return {
    contentId: arg.content_id,
    contentType: 'article',
    isFavorite: false,
  }
}

export const transformNotificationsResponse = (response: GetPendingNotificationsResponse): AddNotificationsActionPayload => {
  const notifications: AddNotificationActionPayload[] = [];
  const { data } = response.data;
  for (const notification of data) {
    let type = notification.type ?? TMNotificationType.AWARD;
    if (type === TMNotificationType.AWARD && !notification.id_achievement) {
      type = TMNotificationType.AWARD_INFO;
    }

    notifications.push({
      id: notification.id.toString(),
      type,
      priority: notification.priority ?? TMNotificationPriority.NORMAL,
      title: notification.title,
      message: notification.message,
      read: !!notification.is_read,
      delivered: !!notification.is_delivered,
      data: {
        idAccount: notification.id_account,
        idAchievement: notification.id_achievement,
        achievementLevelId: notification.achievement_level_id,
      }
    });
  }

  return { notifications };
}

export const transformSpecificNotificationResponse = (response: unknown, meta: FetchBaseQueryMeta | undefined, arg: SpecificNotificationRequest): SpecificNotificationActionPayload => {
  return {
    id: arg.data.notification,
  }
}
